import { render, staticRenderFns } from "./HangUpButton.vue?vue&type=template&id=038347c6"
import script from "./HangUpButton.vue?vue&type=script&lang=js"
export * from "./HangUpButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('038347c6')) {
      api.createRecord('038347c6', component.options)
    } else {
      api.reload('038347c6', component.options)
    }
    module.hot.accept("./HangUpButton.vue?vue&type=template&id=038347c6", function () {
      api.rerender('038347c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/conversations/call-dialog/HangUpButton.vue"
export default component.exports